export default __webpack_public_path__ + "sidebar-header-logo.d0978f59.svg";